// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-close {
  color: gray;
  text-align: right;
  cursor: pointer;
}

.wrap-left-40 {
  margin-left: 40px;
}

.wrap {
  width: max-content;
  display: flex;
  gap: 3rem;
  position: relative;
}
.wrap:after {
  content: "";
  height: 0.1rem;
  background: var(--grey-border);
  position: absolute;
  right: 0;
  bottom: -1.4rem;
  left: 0;
}

.link {
  display: inline-block;
  cursor: pointer;
  font-size: 1.4rem;
  line-height: 1.7rem;
  font-weight: 500;
  color: var(--black);
  position: relative;
}
.link:after {
  content: "";
  width: 0;
  height: 0.4rem;
  background: var(--primary);
  display: block;
  position: absolute;
  bottom: -1.4rem;
  opacity: 0;
  transition: width 0.3s, opacity 0.3s;
  -moz-transition: width 0.3s, opacity 0.3s;
  -webkit-transition: width 0.3s, opacity 0.3s;
  -o-transition: width 0.3s, opacity 0.3s;
}
.link.active:after {
  width: 100%;
  opacity: 1;
}
.link.disable {
  color: var(--grey-text);
  opacity: 0.7;
  cursor: auto;
}`, "",{"version":3,"sources":["webpack://./src/shared/tabs/tabs/tabs.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;EACA,eAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,aAAA;EACA,SAAA;EACA,kBAAA;AACF;AACE;EACE,WAAA;EACA,cAAA;EACA,8BAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;EACA,OAAA;AACJ;;AAGA;EACE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAAF;AAEE;EACE,WAAA;EACA,QAAA;EACA,cAAA;EACA,0BAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,UAAA;EACA,oCACE;EAEF,yCACE;EAEF,4CACE;EAEF,uCACE;AAPN;AAYI;EACE,WAAA;EACA,UAAA;AAVN;AAcE;EACE,uBAAA;EACA,YAAA;EACA,YAAA;AAZJ","sourcesContent":[".tab-close {\n  color: gray;\n  text-align: right;\n  cursor: pointer;\n}\n\n.wrap-left-40 {\n  margin-left: 40px;\n}\n\n.wrap {\n  width: max-content;\n  display: flex;\n  gap: 3rem;\n  position: relative;\n\n  &:after {\n    content: '';\n    height: 0.1rem;\n    background: var(--grey-border);\n    position: absolute;\n    right: 0;\n    bottom: -1.4rem;\n    left: 0;\n  }\n}\n\n.link {\n  display: inline-block;\n  cursor: pointer;\n  font-size: 1.4rem;\n  line-height: 1.7rem;\n  font-weight: 500;\n  color: var(--black);\n  position: relative;\n\n  &:after {\n    content: '';\n    width: 0;\n    height: 0.4rem;\n    background: var(--primary);\n    display: block;\n    position: absolute;\n    bottom: -1.4rem;\n    opacity: 0;\n    transition:\n      width 0.3s,\n      opacity 0.3s;\n    -moz-transition:\n      width 0.3s,\n      opacity 0.3s;\n    -webkit-transition:\n      width 0.3s,\n      opacity 0.3s;\n    -o-transition:\n      width 0.3s,\n      opacity 0.3s;\n  }\n\n  &.active {\n    &:after {\n      width: 100%;\n      opacity: 1;\n    }\n  }\n\n  &.disable {\n    color: var(--grey-text);\n    opacity: 0.7;\n    cursor: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
